document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        if ( document.querySelector(".remove_after_load") && document.querySelector(".hidden_on") ) {   
            document.querySelector(".remove_after_load").classList.add("hidden_on");
            document.querySelector(".hidden_on_start").classList.remove("hidden_on");
        }
    }, 2000);
})
